var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.90396 13.0927C7.90371 13.6028 7.50676 13.9998 6.99664 14C6.74158 14.0001 6.52908 13.901 6.35912 13.7311C6.18916 13.5611 6.09007 13.3486 6.09019 13.0936L6.09268 7.90732L0.906448 7.90981C0.651387 7.90993 0.438883 7.81084 0.268924 7.64088C0.0989656 7.47093 -0.000122341 7.25842 1.13365e-07 7.00336C0.000245021 6.49324 0.397196 6.09629 0.907317 6.09604L6.09355 6.09355L6.09604 0.907318C6.09629 0.397197 6.49324 0.000245021 7.00336 1.13374e-07C7.51348 -0.000244795 7.91005 0.396326 7.90981 0.906448L7.90732 6.09268L13.0936 6.09019C13.6037 6.08995 14.0002 6.48652 14 6.99664C13.9998 7.50676 13.6028 7.90371 13.0927 7.90396L7.90645 7.90645L7.90396 13.0927Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.5f110efdeef990d53dd8a2792f623df5.svg";
export { ForwardRef as ReactComponent };